module.exports = __webpack_public_path__ + "img/Population2020.694d8108.png";